// these selectors work on the generic ClipSuggestion object rather than redux
// state because the ClipSuggestion object is implemented by various different
// redux entities, so there isn't a single selector that can be used to work with
// these objects

import { ClipSuggestion } from 'blocks/ClipSelect/types';
import { ClipSuggestionStatus } from 'redux/middleware/api/podcast-service';

type SuggestionLike = Partial<
  Pick<
    ClipSuggestion,
    'isPreviewRequested' | 'previewWidgetId' | 'widgetId' | 'status'
  >
>;

type IsPreviewLoadingSelectorArgs = {
  isGeneratingPreview: boolean;
  isInitialized: boolean;
  isPreviewReady: boolean;
  previewWidgetId: string | undefined;
};

type DetailViewControlsIsDisabledSelectorArgs = {
  isInitialized: boolean;
};

const isProcessingStatus = (status: ClipSuggestionStatus) =>
  status !== 'completed' && status !== 'failed';

export const previewWidgetIdSelector = (suggestion?: SuggestionLike) => {
  if (!suggestion) return undefined;
  return suggestion.isPreviewRequested
    ? suggestion.previewWidgetId
    : suggestion.widgetId;
};

export const suggestionStatusSelector = (suggestion?: SuggestionLike) =>
  suggestion?.status;

export const isProcessingSelector = (suggestion?: SuggestionLike) => {
  const status = suggestionStatusSelector(suggestion);
  return isProcessingStatus(status);
};

export const detailViewControlsIsDisabledSelector = (
  suggestion: SuggestionLike | undefined,
  { isInitialized }: DetailViewControlsIsDisabledSelectorArgs,
) => isProcessingSelector(suggestion) || !isInitialized;

export const isPreviewLoadingSelector = ({
  isGeneratingPreview,
  isInitialized,
  isPreviewReady,
  previewWidgetId,
}: IsPreviewLoadingSelectorArgs) => {
  return (
    isGeneratingPreview || !isInitialized || !isPreviewReady || !previewWidgetId
  );
};
